import { css } from 'styled-components';

export const fonts = css`
	@font-face {
		font-family: 'Averta';
		src: url('/fonts/averta-light-webfont.eot');
		src: url('/fonts/averta-light-webfont.eot?#iefix') format('embedded-opentype'),
			url('/fonts/averta-light-webfont.woff2') format('woff2'),
			url('/fonts/averta-light-webfont.woff') format('woff'),
			url('/fonts/averta-light-webfont.ttf') format('truetype'),
			url('/fonts/averta-light-webfont.svg#avertalight') format('svg');
		font-weight: 300;
		font-style: normal;

	}

	@font-face {
		font-family: 'Averta';
		src: url('/fonts/averta-regular-webfont.eot');
		src: url('/fonts/averta-regular-webfont.eot?#iefix') format('embedded-opentype'),
			url('/fonts/averta-regular-webfont.woff2') format('woff2'),
			url('/fonts/averta-regular-webfont.woff') format('woff'),
			url('/fonts/averta-regular-webfont.ttf') format('truetype'),
			url('/fonts/averta-regular-webfont.svg#avertaregular') format('svg');
		font-weight: 400;
		font-style: normal;

	}

	@font-face {
		font-family: 'Averta';
		src: url('/fonts/averta-semibold-webfont.eot');
		src: url('/fonts/averta-semibold-webfont.eot?#iefix') format('embedded-opentype'),
			url('/fonts/averta-semibold-webfont.woff2') format('woff2'),
			url('/fonts/averta-semibold-webfont.woff') format('woff'),
			url('/fonts/averta-semibold-webfont.ttf') format('truetype'),
			url('/fonts/averta-semibold-webfont.svg#avertasemibold') format('svg');
		font-weight: 500;
		font-style: normal;
	}

	@font-face {
		font-family: 'Averta';
		src: url('/fonts/Averta-bold.woff') format('woff'),
			url('/fonts/Averta-bold.ttf') format('truetype'),
			url('/fonts/Averta-bold.otf') format('opentype');
		font-weight: 700;
		font-style: normal;
	}
`;

export default fonts;
